import * as factory from '../../../iawp/src/js/factory'
import './publications'
import { updateSectionDefault } from './Utils'
import './contactForm7'

let scrollLabel = {
    fr : 'Scrollez',
    en : 'Scroll',
    de : 'Scrollen'
}

new factory.IAInit()

document.querySelectorAll('.ia-block-dropdown').forEach((dropdown)=>{
    new factory.IADropdown(
        dropdown.querySelector('.ia-block-dropdown-toggle'), 
        dropdown.querySelector('.ia-block-dropdown-content')
    )
})

updateSectionDefault()
if (!!document.querySelectorAll('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        new factory.IAForm(
            form,
            true,
            { 
                rules: {
                    email: {
                        required: true,
                        email: true
                    }
                },
                messagesIdClass: '.contactForm'
            }
        ).formInside(true)
    })
}

if (!!document.querySelectorAll('.ia-block-filters')) {
    document.querySelectorAll('.ia-block-filters').forEach(block => {
        new factory.IAForm(block.querySelector('form'), false).formInside(true)
    })
}

if (!!document.querySelectorAll('.load-more')) {
    document.querySelectorAll('.load-more').forEach(element => {
        element.addEventListener('click', (e)=>{
            new factory.IALoadMore({
                post_type: 'posts', 
                page_to_load: Number(document.querySelector('.ia-block-posts').dataset.page) + 1,
                item: document.querySelector('.ia-block-posts__list-item'), 
                per_page: Number(document.querySelector('.ia-block-posts').dataset.perpage),
                maxpage: Number(document.querySelector('.ia-block-posts').dataset.maxpages),
                lang: document.querySelector('html').lang,
                image:'.ia-block-post__featured-image img',
                title: '.ia-block-post__title a',
                excerpt: '.ia-block-post__excerpt',
            })
        })
    });
}


if (!!document.querySelector('.home .wp-block-media-text.is-style-visual-header')) {
    let currentScrollLabel = scrollLabel[document.querySelector('html').getAttribute('lang')]

    let scrollIconWrapper = document.createElement('div')
    scrollIconWrapper.classList.add('js-scroll-icon-wrapper')

    let scrollIcon = document.createElement('div')
    scrollIcon.classList.add('js-scroll-icon')

    let divScrollLabel = document.createElement('div')
    divScrollLabel.classList.add('js-scroll-label')
    divScrollLabel.innerHTML = currentScrollLabel

    scrollIconWrapper.append(scrollIcon)
    scrollIconWrapper.append(divScrollLabel)
    
    document.querySelector('.home .wp-block-media-text.is-style-visual-header').append(scrollIconWrapper)
}

if (!!document.querySelectorAll('.form-select')) {
    document.querySelectorAll('.form-select').forEach(el => {
        el.parentElement.classList.add('form-inside--select')
    })
}

